import { defineStore } from 'pinia'

export const useIphoneTopUiStore = defineStore('iphoneTopUi', {
  state: () => ({
    /** Global warm / SDK prepare overlay (not during performSale). */
    preparing: false,
    prepareMessage: '',
    /** Nested warm calls (overlay stays until all finish). */
    preparingDepth: 0
  }),
  actions: {
    setPreparing (value, message = '') {
      if (value === true) {
        this.beginPreparing(message)
      } else {
        this.resetPreparing()
      }
    },
    beginPreparing (message = '') {
      this.preparingDepth += 1
      this.preparing = true
      if (message) {
        this.prepareMessage = message
      }
    },
    endPreparing () {
      if (this.preparingDepth > 0) {
        this.preparingDepth -= 1
      }
      this.preparing = this.preparingDepth > 0
      if (!this.preparing) {
        this.prepareMessage = ''
      }
    },
    resetPreparing () {
      this.preparingDepth = 0
      this.preparing = false
      this.prepareMessage = ''
    }
  }
})
